import { render, staticRenderFns } from "./RequestFormGral.vue?vue&type=template&id=515a4c36&"
import script from "./RequestFormGral.vue?vue&type=script&lang=ts&"
export * from "./RequestFormGral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports